import {
  GET_CURRENT_USER_FAIL,
  GET_CURRENT_USER_SUCCESS,
  CLEAR_CURRENT_USER,
} from 'store/constants/action-types';

/**
 * 'hasFetchedUserInfo' becomes true after we've attempted to fetch user info.
 * If it's still false, then we should not perform any redirects.
 */
const initialState = {
  hasFetchedUserInfo: false,
  user: null,
};

export function userReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CURRENT_USER_FAIL:
      return {
        hasFetchedUserInfo: true,
        user: null,
      };
    case GET_CURRENT_USER_SUCCESS:
      return {
        hasFetchedUserInfo: true,
        user: action.payload,
      };
    case CLEAR_CURRENT_USER:
      return {
        hasFetchedUserInfo: false,
        user: null,
      };
    default:
      return state;
  }
}

export default userReducer;
